import React, { useState } from 'react';
import { FlaskConical, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const DisclaimerBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="bg-zinc-900 border-b border-amber-500/20 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-center gap-2">
        <FlaskConical className="h-3.5 w-3.5 text-amber-500 flex-shrink-0" />
        <p className="text-zinc-400 text-xs sm:text-sm text-center">
          <span className="font-semibold text-amber-500">Research Chemicals Only</span>
          <span className="hidden sm:inline"> — All products are sold strictly for laboratory &amp; research purposes. Not intended for human or animal consumption. </span>
          <span className="sm:hidden"> — Not for human consumption. </span>
          <Link to="/terms" className="text-amber-500 hover:text-amber-400 underline underline-offset-2">
            Read full disclaimer
          </Link>
        </p>
        <button
          onClick={() => setDismissed(true)}
          className="text-zinc-600 hover:text-zinc-400 transition-colors flex-shrink-0 ml-2"
          aria-label="Dismiss"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};

export default DisclaimerBanner;
